//src/pages/PathManagePatient/index.jsx
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import PageShell from "../../components/PageShell";
import PatientsTable from "../frontDesk/PatientsTable";
import PendingPatientTest from "./PendingPatientTest";
import IpdPathPatient from "./IpdPathPatientTest";
import AllPatientTest from "./AllPatientTest";
import BilledTests from "./BilledTests"; // Import the new BilledTests component
import CompletedTests from "./CompletedTests"; // Import the new CompletedTests component
import OpdIpdPatients from "./OpdIpdPatients"
import { Typography } from "@mui/material";
import { useSubscriptionCapabilities } from "../../hooks/useSubscriptionCapabilities";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";

const PathManagePatient = () => {
  const { hasPathPackageAccess, loading: capabilitiesLoading } =
    useSubscriptionCapabilities();

  const [selectedTab, setSelectedTab] = useState("1");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  if (capabilitiesLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!hasPathPackageAccess) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={400} p={3}>
        <Typography color="text.secondary" textAlign="center">
          Pathology / Path modules are not included in the Basic package.
        </Typography>
      </Box>
    );
  }

  return (
    <PageShell title="PATIENTS">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList
            {...PAGE_TAB_LIST_PROPS}
            onChange={handleChange}
          >
            <Tab label="Patients In Queue" value="1" />
            {/* <Tab label="All Patients Test" value="2" /> */}
            {/* <Tab label="All Patients" value="3" /> */}
            {/* <Tab label="IPD Patients" value="4" />
            <Tab label="Billed Tests" value="5" /> 
            <Tab label="Completed Tests" value="6" />  */}
            <Tab label="All Patients Test" value="7" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={TAB_PANEL_SX}>
          <PendingPatientTest />
        </TabPanel>
        <TabPanel value="2" sx={TAB_PANEL_SX}>
          <AllPatientTest />
        </TabPanel>
        <TabPanel value="3" sx={TAB_PANEL_SX}>
          <PatientsTable />
        </TabPanel>
        <TabPanel value="4" sx={TAB_PANEL_SX}>
          <IpdPathPatient />
        </TabPanel>
        <TabPanel value="5" sx={TAB_PANEL_SX}>
          <BilledTests /> {/* New Component for Billed Tests */}
        </TabPanel>
        <TabPanel value="6" sx={TAB_PANEL_SX}>
          <CompletedTests /> {/* New Component for Completed Tests */}
        </TabPanel>
        <TabPanel value="7" sx={TAB_PANEL_SX}>
          <OpdIpdPatients /> {/* New Component for opd/ipd patients Tests */}
        </TabPanel>
      </TabContext>
    </PageShell>
  );
};

export default PathManagePatient;
